<template>
	<span>{{ activeCountry }}</span>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		computed: {
			...mapState({
				localization: state => state.localization,
			}),
		},

		data(){
			return {
				activeCountry: ""
			}
		},

		mounted(){
			this.getActiveCountry()
		},

		methods: {
			getActiveCountry(){
				this.localization.shippingCountries.forEach(shippingCountry => {
					if(shippingCountry.id === this.localization.shippingCountryId){
						this.activeCountry = shippingCountry.isoCode2
					}
				});

			}
		}
	}

</script>
